import React from 'react';
import { useHistory } from 'react-router-dom';
import { Label, Icon } from 'semantic-ui-react';

const SearchLabel = ({ queries, project, textDisplay }) => {
  const history = useHistory();
  const params = new URLSearchParams();
  queries.forEach((query) => {
    params.append('queries', query);
  });
  return (
    <Label
      size="small"
      as="a"
      className="search-label"
      onClick={() => {
        let search = `?${params.toString()}`;
        if (project) {
          search = `${search}&projects=${project.id}`;
        }
        history.push({ pathname: '/search', search });
      }}
    >
      {!textDisplay ? queries[0] : (
        <>
          <Icon name="search" />
          {textDisplay}
        </>
      )}
    </Label>
  );
};

export default SearchLabel;
